const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB'];
export function formatBytes(bytes, decimals = 1) {
    if (bytes === null || bytes === undefined) {
        return '–';
    }
    const sign = bytes < 0 ? '-' : '';
    let value = Math.abs(bytes);
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
        value /= 1024;
        unit++;
    }
    return `${sign}${value.toFixed(unit === 0 ? 0 : decimals)} ${units[unit]}`;
}
//# sourceMappingURL=format.js.map